import ConfigProvider from 'antd/es/config-provider';

import * as Style from './Input.style';

interface Props {
  prefix?: string;
  type?: string;
  autoComplete?: string;
  placeholder?: string;
  width?: string;
  height?: string;
}

const Input = ({
  prefix,
  type,
  autoComplete,
  placeholder,
  width,
  height,
  ...rest
}: Props) => {
  return (
    <ConfigProvider
      theme={{
        hashed: false,
        components: {
          Input: {
            activeBg: '#ffffffb3',
            hoverBg: '#ffffffb3',
            paddingInline: 25,
          },
        },
      }}
    >
      <Style.Input
        variant="borderless"
        prefix={prefix}
        type={type}
        autoComplete={autoComplete}
        placeholder={placeholder}
        width={width}
        height={height}
        {...rest}
      />
    </ConfigProvider>
  );
};

export default Input;
